// Ract Imports
import React from "react";

// Package Imports
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";
import { observer } from "mobx-react";
import { ToastContainer, toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import moment from "moment";

// Project Imports
import NewPassword from "./login/components/NewPassword";
import Dashboard from "./dashboard/components/Dashboard";
import Temp from "./temp";
import Login from "./login/components/Login";
import AuthStore from "../modules/login/store/AuthStore";
import Styleguide from "./styleguide/Styleguide";
import { ErrorModal, CustomizationModal } from "../components";
import HeaderComponent from "./HeaderComponent";
import StorageKeys from "constants/StorageKeys";
import * as Constants from "constants/Constants";
import { TOKEN_EXPIRY_TIME_IN_MINUTES } from "constants/Constants";

// CSS Imports
require("normalize.css/normalize.css");
require("styles/typo.css");
require("styles/App.css");
require("styles/common-colors.css");
import "react-toastify/dist/ReactToastify.css";
import QmsDashboard from "./dashboard/components/QmsDashboard";
import QmsHeaderComponent from "./QmsHeaderComponent";
import OptimizationStore from "./optimization/store/OptimizationStore";
import SharePdf from "components/ui/share-pdf-via-whatsapp/SharePdf";
import setCookie from "utils/journeyIdCookie/setJourneyId";
import getCookieValue from "utils/getCookieValue/getCookieValue";
import setCookieValue from "utils/getCookieValue/setCookieValue";
import CustomerFeedbackScreen from "../components/ui/customer-feedback/customerFeedbackScreen";

const history = createBrowserHistory();

const AppComponent = observer(
  class AppComponent extends React.Component {
    constructor() {
      super();
      this.state = { isLoading: false };
      global.toINR = (value = "", isRound = true) => {
        return (
          <span>
            {" "}
            <span className='rupee-sign hide-rupee-sign'>&#8377;</span> {isRound ? this.getRoundValue(value).toLocaleString("en-IN") : value && value.toLocaleString("en-IN")}
          </span>
        );
      };
      global.toINRForSlider = (value = "", isRound = true) => {
        return (
          <span className='font-size-12'>
            {" "}
            <span className='rupee-sign hide-rupee-sign'>&#8377;</span> {isRound ? this.getRoundValue(value).toLocaleString("en-IN") : value && value.toLocaleString("en-IN")}
          </span>
        );
      };
      global.getRoundValue = this.getRoundValue;
      global.showToast = (toastTitle = "", toastMsg = "") => {
        if (toastTitle == "success") {
          toast.success(toastMsg);
        } else if (toastTitle == "danger") {
          toast.error(toastMsg);
        } else {
          toast.warn(toastTitle);
        }
      };
      global.isLoading = () => this.state.isLoading;
      global.loading = (isLoading) => { this.setState({}); };
      global.mainLoading = (isLoading) => {
        this.setState({ isLoading });
      };
    }
    async componentDidMount() {
      const urlParams = new URLSearchParams(location.search);
      let authToken;
      const authTokenFromUrl = urlParams.get("token");
      const journeyId = urlParams.get("journey_id");
      const source_system = urlParams.get("source");
      const isPasaCampaign = urlParams.get("is_pasa_campaign");
      const isPasaActive = urlParams.get("is_pasa_active");
      const maxUpsellValue = urlParams.get("max_upsell_value");
      
      if (authTokenFromUrl) {
        authToken = authTokenFromUrl
        let checkToken = jwt_decode(authTokenFromUrl)
        // setCookieValue("token", authTokenFromUrl)
        if (location.pathname != "/u2-customer-feedback" && checkToken.SourceFrom !== 'Distribution_App' && source_system !== Constants.BANCA_JOURNEY && source_system !== Constants.SAMS_JOURNEY) {
          window.location.href = process.env.REACT_APP_PRAGATI_URL
        }
      } else {

        authToken = document.cookie.split("; ").find((row) => row.startsWith("token="))?.split("=")[1];

      }

      if ((source_system === Constants.BANCA_JOURNEY || source_system === Constants.SAMS_JOURNEY) && journeyId) {
        setCookie(Constants.COOKIE_PARA_NAME_FOR_JOURNEY_ID, journeyId)
        sessionStorage.setItem("source", source_system);
        
        if (isPasaCampaign === "True") {
          sessionStorage.setItem(StorageKeys.SHOW_PASA, true)
        } else if (isPasaCampaign === "False") {
          sessionStorage.setItem(StorageKeys.SHOW_PASA, false)
        }

        if (isPasaActive === "True") {
          sessionStorage.setItem(StorageKeys.IS_PASA_PRODUCT, true)
        } else if (isPasaActive === "False") {
          sessionStorage.setItem(StorageKeys.IS_PASA_PRODUCT, false)
        }
        if(maxUpsellValue){
            sessionStorage.setItem(StorageKeys.MAX_UPSELL_VALUE, maxUpsellValue)
        }
      }
      console.log("authToken ", authToken, "user_journey", journeyId, "source", source_system)

      // let isTokenExpired = await AuthStore.authentication.checkIfTokenExpired(authToken);

      // if(isTokenExpired){
      // Session Expired
      // TODO show expired session popup and redirect back to pragati.
      // }else{
      // Session is valid proceed ahead
      if (authToken !== undefined && authToken !== null) {
        // var decodedToken = jwt_decode(authToken);
        // var expiryTime = decodedToken.exp;
        // var expiryTimeConstant = TOKEN_EXPIRY_TIME_IN_MINUTES;
        // var momentTime = moment.unix(expiryTime).subtract(expiryTimeConstant, "m");
        // if (moment().isAfter(momentTime)) {
        //   AuthStore.setIsSessionExpired(true)
        // } else {
        await sessionStorage.setItem(StorageKeys.AUTH_TOKEN, authToken);
        // AuthStore.setIsSessionExpired(false)
        // }


      }



      if (authToken) {
        var decodedToken = jwt_decode(authToken);
        var agentID = decodedToken.Vendor + "-" + decodedToken.LoginCode
        sessionStorage.setItem(StorageKeys.SET_AGENT_ID_SESSION_STORAGE, agentID)
      } else if (sessionStorage.getItem(StorageKeys.AUTH_TOKEN)) {
        var sessionStorageToken = sessionStorage.getItem(StorageKeys.AUTH_TOKEN);
        var agentID = sessionStorageToken.Vendor + "-" + sessionStorageToken.LoginCode
        sessionStorage.setItem(StorageKeys.SET_AGENT_ID_SESSION_STORAGE, agentID)
      } else {

      }

      if (!authToken && !sessionStorage.getItem(StorageKeys.AUTH_TOKEN)) {
        window.location.href = process.env.REACT_APP_PRAGATI_URL
        return
      }
      await AuthStore.authentication.authenticate();
      await AuthStore.authentication.refreshToken();
      // }
    }

    closeSession = () => {
      window.location.href = process.env.REACT_APP_PRAGATI_URL
      return
    }

    getRoundValue = (value) => Number.parseInt(value) || "0";

    browserHistory = () => { };

    render() {
      if (AuthStore.isUserLogin == null) {
        return <div>loading....</div>;
      }
      // Note : Set isUserLogin value dynamically when login flow working properly
      // const isUserLogin = AuthStore.isUserLogin;

      const isUserLogin = true;
      const { isLoading } = this.state;
      console.log("isLoading",isLoading)
      let currentLocation = window.location.pathname

      return (
        <div>
          {isLoading && !currentLocation.includes("customization") && !currentLocation.includes("preview-share") && !currentLocation.includes("quotation-preview") && (
            <div className='loader-wrapper'>
              <div className='loader'></div>
            </div>
          )}
          {/* {(currentLocation.includes("customization") && OptimizationStore.showMainLoading) &&
            <CustomizationModal
              show={isLoading}
              loaderMsg={Constants.CUSTOMIZATION_LOADER_MSG}
              redirectPath="family-details"
            />
          } */}
          {currentLocation.includes("customization-old") &&
            <CustomizationModal
              show={isLoading}
              loaderMsg={Constants.CUSTOMIZATION_LOADER_MSG}
              redirectPath="family-details"
            />
          }
          {(currentLocation.includes("preview-share")) &&
            <CustomizationModal
              show={isLoading}
              loaderMsg={Constants.SOLUTION_PREVIEW_LOADER_MSG}
              redirectPath="customization"
            />
          }
          {/* {currentLocation.includes("quotation-preview") &&
            <CustomizationModal
              show={isLoading}
              loaderMsg={Constants.SOLUTION_PREVIEW_LOADER_MSG}
              redirectPath="solution"
            />
          } */}

          <Router history={history} onUpdate={() => { }}>
            <Switch>
             <AuthRoute exact path='/u2-customer-feedback' component={CustomerFeedbackScreen} isUserLogin={isUserLogin} />
              <AuthRoute exact path='/qms/:selectedPage' component={QmsHeaderComponent} isUserLogin={isUserLogin} />
              <AuthRoute exact path='/qms' component={QmsDashboard} isUserLogin={isUserLogin} />
              <Route exact path='/newpassword' component={NewPassword} />
              <NoAuthRoute exact path='/temp' component={Temp} />
              <NoAuthRoute exact path='/styleguide' component={Styleguide} />
              <NoAuthRoute exact path='/login' component={Login} isUserLogin={isUserLogin} />
              <NoAuthRoute exact path='/' component={Login} isUserLogin={isUserLogin} />
              <AuthRoute exact path='/:selectedPage' component={HeaderComponent} isUserLogin={isUserLogin} />
              <AuthRoute exact path='/' component={HeaderComponent} isUserLogin={isUserLogin} />
              <AuthRoute exact path='/' component={Dashboard} isUserLogin={isUserLogin} />
            </Switch>
          </Router> 
          <ToastContainer position={toast.POSITION.TOP_RIGHT} autoClose={1000} />
          <div>
            <form className='d-none' id='redirect-to-pragati-on-exit' action={localStorage.getItem(StorageKeys.PRAGATI_HOME_URL)} method={"POST"}>
              <input type='text' name='Pragati_Token' value={sessionStorage.getItem(StorageKeys.AUTH_TOKEN)} />
              <input type='text' name='LoginCode' value={localStorage.getItem(StorageKeys.LOGIN_CODE)} />
              <input type='text' name='Vendor' value={localStorage.getItem(StorageKeys.VENDOR)} />
              <input type='text' name='SourceFrom' value={localStorage.getItem(StorageKeys.SOURCE_FROM)} />
              <input type='text' name='LoginAgentCode' value={localStorage.getItem(StorageKeys.LOGIN_AGENT_CODE)} />
              <button type='submit'>Submit</button>
            </form>
          </div>
          <ErrorModal onHideModal={this.closeSession} showModal={AuthStore.isSessionExpired} title={"Session Expired. Please login again"} hideResumeSession={true} />;
        </div>
      );
    }
  }
);

function AuthRoute({ component: Component, isUserLogin, ...rest }) {
  if (!sessionStorage.getItem(StorageKeys.AUTH_TOKEN)) {
    window.location.href = process.env.REACT_APP_PRAGATI_URL
  }
  return (
    <Route
      {...rest}
      render={(props) =>
        isUserLogin ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
}

function NoAuthRoute({ component: Component, isUserLogin, ...rest }) {

  if (!sessionStorage.getItem(StorageKeys.AUTH_TOKEN)) {
    window.location.href = process.env.REACT_APP_PRAGATI_URL
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        !isUserLogin ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/choose-needs",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
}

const InvalidJourneyModal = (props) => {
  const closeModal = async () => {
    AuthStore.closeInvalidJourneyIdModal();
    if (AuthStore.axiosMsg.toLowerCase() == "not found") {
      await props.history.push("/choose-needs");
    }
  };

  return <ErrorModal onHideModal={closeModal} showModal={AuthStore.isInvalidJourneyId} title={AuthStore.axiosMsg} hideResumeSession={true} />;
};

AppComponent.defaultProps = {};

export default AppComponent;
